/*proj4/lib/projections/longlat*/
function _(require, module, exports) {
    exports.init = function () {
    };
    function identity(pt) {
        return pt;
    }
    exports.forward = identity;
    exports.inverse = identity;
    exports.names = [
        'longlat',
        'identity'
    ];
}